import { Typography } from '@mui/material';

import { useUpdatePiecesMutation } from '@api/piece';
import { PieceAction } from '@apiContract';

import { DialogConfirmation } from '@uiKit/DialogConfirmation';

import { ActionComponentProps } from '../../index';

export const Submit = ({ mailpieces, actionStarted, onActionFinish }: ActionComponentProps) => {
  const [updatePieces, { isLoading }] = useUpdatePiecesMutation();

  const confirmAction = async () => {
    await updatePieces({
      pieces: mailpieces.map((piece) => ({ id: piece.id })),
      action: PieceAction.Submit,
    }).unwrap();

    onActionFinish();
  };

  const content =
    mailpieces.length === 1 ? (
      'Are you sure you would like to send this item to the recipient?'
    ) : (
      <Typography variant="body1" color="text.secondary">
        Are you sure you would like to send <strong>{mailpieces.length}</strong> item(s) to recipients?
      </Typography>
    );

  return (
    <DialogConfirmation
      open={actionStarted}
      loading={isLoading}
      maxWidth="xs"
      title={mailpieces.length === 1 ? 'Send item' : 'Send selected items'}
      content={content}
      acceptButtonHandleClick={confirmAction}
      cancelButtonHandleClick={onActionFinish}
      acceptButtonTitle="Send"
      cancelButtonTitle="Cancel"
    />
  );
};
